import * as React from 'react';
import {
  Breadcrumbs as BaseBreadcrumbs,
  IBreadcrumbProps,
  Breadcrumb,
} from '@mc/react-core';
import classNames from 'classnames';

type Props = Omit<
  React.ComponentProps<typeof BaseBreadcrumbs> & {
    disabled?: boolean;
  },
  'breadcrumbRenderer'
>;

const ClassNameNS = 'card-breadcrumbs';
const ClassName = ` ${ClassNameNS}`;

export class CardBreadcrumbs extends React.PureComponent<Props> {
  renderBreadcrumb = ({ text, href, ...restProps }: IBreadcrumbProps) => {
    return <Breadcrumb {...restProps}>{text}</Breadcrumb>;
  };

  render() {
    const { className, disabled, ...other } = this.props;
    let cls = classNames(ClassName, className, {
      disabled: disabled,
    });

    return (
      <BaseBreadcrumbs
        {...other}
        className={cls}
        breadcrumbRenderer={this.renderBreadcrumb}
      />
    );
  }
}
